export default __webpack_public_path__ + "static/homes-for-heroes-logo-927883e7180b63e330da21dba7278115.png";